import { pushErrorFromAPI, pushSuccess } from 'src/utilities/notifications';
import { IGroup, SHORT_SEARCH_DELAY } from 'src/utilities/useSearchHooks';
import { sdk } from 'src/utilities/sdk';

type UseEditGroupProps = {
  onSuccess: () => void;
};

type UseEditGroupReturn = {
  mutate: (
    groupInfo: Pick<IGroup, 'id' | 'name' | 'description'>,
    corpId: string
  ) => Promise<void>;
};

export const useEditGroup = ({
  onSuccess,
}: UseEditGroupProps): UseEditGroupReturn => {
  async function mutate(groupInfo: IGroup, corpId: string): Promise<void> {
    try {
      await sdk.http.put(
        `/corp-admin/${corpId}/groups/${groupInfo.id}`,
        groupInfo
      );

      // use a promise to allow form 'isSubmitting' to handle button disabled state
      await new Promise<void>((resolve) => {
        // add search delay in hopes of ensuring new data reaches the elastic search in time
        setTimeout(() => {
          pushSuccess('This group has been updated.');

          onSuccess();
          resolve();
        }, SHORT_SEARCH_DELAY);
      });
    } catch ({ status, data }) {
      const fallbackErrorMessage =
        'There was a problem editing this group. Try again.';

      pushErrorFromAPI(
        {
          status,
          errors: data,
        },
        {
          fallbackMessage: fallbackErrorMessage,
        }
      );
    }
  }

  return {
    mutate,
  };
};
